/**
 * cart-page.js — trang giỏ hàng (cart.html, mục 16) + phần TÍNH TIỀN dùng chung cho
 * cả luồng mua hàng (giỏ hàng → thanh toán → đặt hàng thành công).
 *
 * 1) window.WBOrder — một chỗ duy nhất giữ luật tiền, để giỏ hàng và trang thanh toán
 *    không bao giờ ra hai con số khác nhau cho cùng một giỏ:
 *      FREE_SHIP                 ngưỡng miễn phí giao tiêu chuẩn (2.000.000₫, mục 16)
 *      coupon()                  mã đang áp ('' nếu không có)
 *      applyCoupon(code)         → { ok: true, code } | { ok: false, error }
 *      removeCoupon()
 *      rate()                    tỉ lệ giảm của mã đang áp (0.1 = 10%)
 *      discount(subtotal)        tiền giảm, làm tròn tới nghìn đồng
 *      standardFee(subtotal)     phí giao tiêu chuẩn: 0 khi đủ ngưỡng, không thì 30.000₫
 *      bindCoupon(root)          gắn ô [data-coupon] (nhập · Áp dụng · Bỏ mã)
 *    Đổi mã phát sự kiện `wb:coupon` trên document — trang nào hiện tiền thì nghe nó.
 *    Đặt trong file này (không tách module riêng) vì giỏ hàng là bước đầu tiên dùng tới;
 *    checkout.js / order-success.js gọi lười trong DOMContentLoaded nên thứ tự gộp file
 *    của gulp không ảnh hưởng.
 *
 * 2) Trang giỏ hàng: vẽ dòng sản phẩm từ WBStore.cart.items(), tính lại khi đổi số lượng
 *    (sự kiện `change` mà stepper.js phát) hoặc khi giỏ đổi ở nơi khác (`wb:cart`).
 *    Nút × dùng chung thuộc tính [data-cart-remove] với mini cart — cart.js xoá + báo
 *    toast, file này chỉ vẽ lại và trả focus về dòng kế bên.
 *    Markup cần: [data-cart-page] chứa [data-cart-layout], [data-cart-lines],
 *    [data-cart-empty], [data-free-ship], [data-total="…"], [data-cart-bar].
 *
 * Mã giảm giá demo: WINEBOSS10 (giảm 10%), lưu ở localStorage `wb_coupon`. Lần đầu vào
 * chưa có khoá thì coi như đã áp sẵn — giống giỏ mẫu của store.js, để bản tĩnh khớp ảnh
 * guideline (3.951.000₫) mà không phải tự gõ mã.
 *
 * WP/WooCommerce: XOÁ cả file. Tiền do WC()->cart->calculate_totals() tính, mã giảm giá là
 * shop_coupon (apply_coupon qua AJAX ?wc-ajax=apply_coupon), ngưỡng miễn phí lấy từ
 * phương thức Free shipping; đổi số lượng thì bấm hộ button[name=update_cart].
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY_COUPON = 'wb_coupon';
    var FREE_SHIP = 2000000;
    var STANDARD_FEE = 30000;
    var DEFAULT_COUPON = 'WINEBOSS10';
    // Mã demo: chỉ một mã, giảm 10% trên tạm tính
    var COUPONS = { WINEBOSS10: 0.1 };

    var memory = null;

    function store() {
        return window.WBStore;
    }

    function money(value) {
        return store() ? store().money(value) : Math.round(value).toLocaleString('vi-VN') + '₫';
    }

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    function emit(name) {
        var event;
        try {
            event = new CustomEvent('wb:' + name);
        } catch (e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('wb:' + name, false, false, null);
        }
        document.dispatchEvent(event);
    }

    // ===================== Mã giảm giá =====================
    // localStorage có thể ném lỗi (Safari riêng tư) — khi đó giữ mã trong biến, sống hết phiên trang.
    function readCoupon() {
        var raw = null;
        try {
            raw = window.localStorage.getItem(KEY_COUPON);
        } catch (e) {
            raw = memory;
        }
        if (raw === null) {
            writeCoupon(DEFAULT_COUPON);
            return DEFAULT_COUPON;
        }
        return COUPONS[raw] ? raw : '';
    }

    function writeCoupon(code) {
        memory = code;
        try {
            window.localStorage.setItem(KEY_COUPON, code);
        } catch (e) {
            /* giữ trong bộ nhớ */
        }
    }

    function normalize(code) {
        return String(code || '').replace(/\s+/g, '').toUpperCase();
    }

    function applyCoupon(code) {
        code = normalize(code);
        if (!code) return { ok: false, error: 'Nhập mã giảm giá trước khi bấm Áp dụng.' };
        if (!COUPONS[code]) return { ok: false, error: 'Mã “' + code + '” không hợp lệ hoặc đã hết hạn.' };
        writeCoupon(code);
        emit('coupon');
        return { ok: true, code: code };
    }

    // Ghi chuỗi rỗng chứ không xoá khoá: xoá khoá thì lần sau lại bị coi là "lần đầu" và tự áp lại
    function removeCoupon() {
        writeCoupon('');
        emit('coupon');
    }

    function rate() {
        var code = readCoupon();
        return code ? COUPONS[code] : 0;
    }

    function discount(subtotal) {
        return Math.round((subtotal * rate()) / 1000) * 1000;
    }

    function standardFee(subtotal) {
        return subtotal >= FREE_SHIP ? 0 : STANDARD_FEE;
    }

    // Ô mã giảm giá — cùng markup ở giỏ hàng và thanh toán. Không dùng <form> riêng vì
    // ở trang thanh toán ô này nằm TRONG form đặt hàng (form lồng form là HTML sai),
    // nên phím Enter trong ô phải chặn lại, không thì nó gửi luôn đơn hàng.
    function bindCoupon(root) {
        if (!root) return;
        var input = root.querySelector('[data-coupon-input]');
        var apply = root.querySelector('[data-coupon-apply]');
        var msg = root.querySelector('[data-coupon-msg]');
        var text = root.querySelector('[data-coupon-text]');
        var remove = root.querySelector('[data-coupon-remove]');
        var field = input ? input.closest('.field') : null;
        var icon = msg ? msg.querySelector('i') : null;

        function setError(error) {
            if (field) field.classList.toggle('field--error', !!error);
            if (input) {
                if (error) input.setAttribute('aria-invalid', 'true');
                else input.removeAttribute('aria-invalid');
            }
        }

        // Hiện trạng thái mã đang áp mà KHÔNG đụng vào chữ khách đang gõ trong ô
        function showApplied() {
            var code = readCoupon();
            setError('');
            if (!msg) return;
            if (code) {
                msg.hidden = false;
                msg.classList.add('is-success');
                if (icon) icon.className = 'ph-bold ph-check';
                if (text) text.textContent = 'Đã áp dụng ' + code + ' · giảm ' + Math.round(COUPONS[code] * 100) + '%';
                if (remove) remove.hidden = false;
            } else {
                msg.hidden = true;
            }
        }

        function sync() {
            if (input) input.value = readCoupon();
            showApplied();
        }

        function showError(error) {
            setError(error);
            if (!msg) return;
            msg.hidden = false;
            msg.classList.remove('is-success');
            if (icon) icon.className = 'ph-bold ph-warning-circle';
            if (text) text.textContent = error;
            if (remove) remove.hidden = true;
        }

        function submit() {
            var result = applyCoupon(input ? input.value : '');
            if (!result.ok) {
                showError(result.error);
                if (input) input.focus();
            }
        }

        if (apply) apply.addEventListener('click', submit);
        if (input) {
            input.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    submit();
                }
            });
            // Đang báo lỗi mà khách gõ lại thì gỡ viền đỏ ngay, không bắt chờ bấm lần nữa
            input.addEventListener('input', function () {
                if (field && field.classList.contains('field--error')) showApplied();
            });
        }
        if (remove) {
            remove.addEventListener('click', function () {
                removeCoupon();
                if (input) {
                    input.value = '';
                    input.focus();
                }
            });
        }

        document.addEventListener('wb:coupon', sync);
        sync();
    }

    window.WBOrder = {
        FREE_SHIP: FREE_SHIP,
        STANDARD_FEE: STANDARD_FEE,
        coupon: readCoupon,
        applyCoupon: applyCoupon,
        removeCoupon: removeCoupon,
        rate: rate,
        discount: discount,
        standardFee: standardFee,
        bindCoupon: bindCoupon,
        esc: esc
    };

    // ===================== Trang giỏ hàng =====================
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var layout = page.querySelector('[data-cart-layout]');
    var list = page.querySelector('[data-cart-lines]');
    var empty = page.querySelector('[data-cart-empty]');
    var freeShip = page.querySelector('[data-free-ship]');
    var bar = document.querySelector('[data-cart-bar]');
    var focusIndex = -1;

    function lineHtml(item) {
        var s = store();
        var key = s.cart.key(item);
        var name = esc(item.name);
        var meta = item.variant ? [item.country, item.year, item.variant].filter(Boolean).join(' · ') : item.meta;
        var flag = item.flag ? '<img class="flag flag--sm" src="images/flags/' + esc(item.flag) + '.png" alt="" width="40" height="27" />' : '';

        return '<li class="cart-line cart_item" data-cart-line="' + esc(key) + '">' +
            '<a class="thumb thumb--lg cart-line__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
            '<img src="' + esc(item.image) + '" alt="" width="600" height="800" /></a>' +
            '<div class="cart-line__body">' +
            '<div class="cart-line__head"><a class="cart-line__name product-name" href="' + esc(item.url) + '">' + name + '</a>' +
            '<button class="cart-line__remove remove" type="button" aria-label="Xoá ' + name + ' khỏi giỏ" data-cart-remove="' + esc(key) + '">' +
            '<i class="ph-bold ph-x" aria-hidden="true"></i></button></div>' +
            '<p class="cart-line__meta">' + flag + '<span>' + esc(meta || '') + '</span></p>' +
            '<div class="cart-line__foot">' +
            '<div class="qty qty--sm product-quantity" data-stepper>' +
            '<button class="qty__btn" type="button" data-stepper-down aria-label="Bớt một chai"><i class="ph-bold ph-minus" aria-hidden="true"></i></button>' +
            '<input class="qty__input" type="number" name="cart[' + esc(key) + '][qty]" value="' + item.qty + '" min="1" max="' + s.maxQty + '" inputmode="numeric" data-stepper-input data-cart-qty="' + esc(key) + '" aria-label="Số lượng ' + name + '" />' +
            '<button class="qty__btn" type="button" data-stepper-up aria-label="Thêm một chai"><i class="ph-bold ph-plus" aria-hidden="true"></i></button>' +
            '</div>' +
            '<span class="cart-line__total money product-subtotal" data-line-total>' + money(item.price * item.qty) + '</span>' +
            '</div></div></li>';
    }

    function syncSteppers() {
        if (!window.WBStepper) return;
        [].slice.call(list.querySelectorAll('[data-stepper]')).forEach(window.WBStepper.sync);
    }

    function setText(selector, value) {
        [].slice.call(document.querySelectorAll(selector)).forEach(function (el) {
            el.textContent = value;
        });
    }

    // Chiều cao thanh đáy đổi khi dòng "Tiết kiệm…" ẩn/hiện — navigation.js chỉ đo lúc
    // load/resize nên đo lại ở đây để nội dung cuối trang không bị thanh che mất.
    function measureBar() {
        if (bar && !bar.hidden && bar.offsetHeight) {
            document.documentElement.style.setProperty('--action-bar-height', bar.offsetHeight + 'px');
        }
    }

    function render() {
        var s = store();
        var items = s.cart.items();
        var isEmpty = !items.length;

        if (layout) layout.hidden = isEmpty;
        if (empty) empty.hidden = !isEmpty;
        if (bar) bar.hidden = isEmpty;
        // Giỏ rỗng thì không còn thanh "Thanh toán" — trả tab bar về cho mobile
        document.body.classList.toggle('has-action-bar', !isEmpty);
        if (isEmpty) return;

        // Cùng bộ dòng thì chỉ cập nhật số, KHÔNG vẽ lại: vẽ lại làm mất focus của ô số
        // lượng đang gõ / nút +− đang bấm liên tục.
        var signature = items.map(s.cart.key).join(',');
        if (list.getAttribute('data-signature') !== signature) {
            list.innerHTML = items.map(lineHtml).join('');
            list.setAttribute('data-signature', signature);
        } else {
            items.forEach(function (item) {
                var line = list.querySelector('[data-cart-line="' + s.cart.key(item) + '"]');
                if (!line) return;
                var input = line.querySelector('[data-cart-qty]');
                if (input && document.activeElement !== input) input.value = item.qty;
                line.querySelector('[data-line-total]').textContent = money(item.price * item.qty);
            });
        }
        syncSteppers();

        var subtotal = s.cart.subtotal();
        var off = discount(subtotal);
        var fee = standardFee(subtotal);
        var total = Math.max(0, subtotal - off + fee);
        var count = s.cart.count();

        // Thanh tiến độ: tính trên tạm tính TRƯỚC giảm giá — đúng luật min_amount mặc định của WooCommerce
        if (freeShip) {
            var pct = Math.min(100, Math.round((subtotal / FREE_SHIP) * 100));
            var bar2 = freeShip.querySelector('[data-free-ship-bar]');
            var text = freeShip.querySelector('[data-free-ship-text]');
            freeShip.style.setProperty('--pct', pct + '%');
            if (bar2) bar2.setAttribute('aria-valuenow', String(pct));
            if (text) {
                text.innerHTML = subtotal >= FREE_SHIP
                    ? 'Đơn hàng của bạn được miễn phí giao hàng tiêu chuẩn.'
                    : 'Mua thêm <strong>' + money(FREE_SHIP - subtotal) + '</strong> để được miễn phí giao hàng.';
            }
        }

        setText('[data-total="subtotal"]', money(subtotal));
        setText('[data-total="discount"]', '−' + money(off));
        setText('[data-total="shipping"]', fee ? money(fee) : 'Miễn phí');
        setText('[data-total="total"]', money(total));
        setText('[data-cart-count-text]', count + ' sản phẩm');
        [].slice.call(page.querySelectorAll('[data-total-row="discount"]')).forEach(function (row) {
            row.hidden = !off;
        });

        var saving = document.querySelector('[data-cart-saving]');
        if (saving) {
            saving.hidden = !off;
            saving.textContent = 'Tiết kiệm ' + money(off);
        }
        measureBar();
    }

    // Trả focus về nút × của dòng đứng vào chỗ dòng vừa xoá (hoặc dòng trước nếu xoá dòng cuối);
    // xoá hết thì đưa sang nút "Tiếp tục mua sắm" — focus không bao giờ rơi về <body>.
    function restoreFocus() {
        if (focusIndex < 0) return;
        var buttons = list.querySelectorAll('[data-cart-remove]');
        var target = buttons[Math.min(focusIndex, buttons.length - 1)];
        if (!buttons.length || (layout && layout.hidden)) target = empty ? empty.querySelector('a, button') : null;
        focusIndex = -1;
        if (target) target.focus();
    }

    function init() {
        if (!store()) return;

        render();
        bindCoupon(page.querySelector('[data-coupon]'));

        // Đổi số lượng: nút +−, gõ tay rồi rời ô, phím mũi tên — stepper.js đều quy về `change`
        page.addEventListener('change', function (event) {
            var input = event.target;
            if (!input.matches || !input.matches('[data-cart-qty]')) return;
            store().cart.setQty(input.getAttribute('data-cart-qty'), input.value);
        });

        // Nghe trên danh sách nên chạy TRƯỚC listener xoá của cart.js ở document (sự kiện nổi
        // từ trong ra) — ở đây chỉ ghi nhớ vị trí nút vừa bấm, việc xoá để cart.js làm
        list.addEventListener('click', function (event) {
            var remove = event.target.closest ? event.target.closest('[data-cart-remove]') : null;
            if (!remove) return;
            var buttons = [].slice.call(list.querySelectorAll('[data-cart-remove]'));
            focusIndex = buttons.indexOf(remove);
        });

        document.addEventListener('wb:cart', function () {
            render();
            restoreFocus();
        });
        document.addEventListener('wb:coupon', render);
        window.addEventListener('load', measureBar);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
